import { api } from '..'

export const assignTagToDevice = (deviceId: string) => (tag: string) =>
  api.post(`/v1/devices/${deviceId}/tags`, { nameTags: [tag] })
